import { useMemo } from 'react'

export default function useDataConfiguration(props) {
  return useMemo(() => {
    return {
      variables: {
        leadId: props.leadId,
      },
      pause: !props.leadId,
    }
  }, [props])
}
